export default "__VITE_ASSET__BCMZcA9i__"